import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Modal } from 'antd';
import { ReactComponent as SearchIcon } from '../../../assets/images/search.svg';

import {
  Wrapper,
  SearchWrapper,
  SearchContainer,
  SearchItemWrapper,
  Container,
  Divider,
} from './styles';
import { useAuthStore } from "../../../store/auth/authStore";
import { StyledParagraph } from "../../CustomAntdComponents/Typography";
import { useFlightSearchStore } from "../../../store/flightSearch/flightSearchStore";
import FlightSearchDesktop from "./FlightSearchDesktop";
import { getAirportStateName } from "../../TripSummary/helper";
import { useStore } from "../../../store/global/appStore";
import { FlightSearchStore } from "../../../store/flightSearch/types";
import { generateMultiCityFlightRoutes } from "../../FlightSearch/helper";
import { PRIMARY } from '../../../utils/colors';
import { formatDisplayDate, formatReturnDisplayDate } from '../../../screens/SearchListings/helpers';
import moment from 'moment';


type Props = {
  navigateHandler: () => void,
  refetchSearch: (arg: FlightSearchStore) => void,
  modify: boolean,
  onModifyChange: (value: boolean) => void
}
function FlightDesktopHeader({ navigateHandler, modify, onModifyChange, refetchSearch }: Props) {
  const modalContainerRef = useRef(null);

  const { airports } = useStore();
  const { isLoggedIn, setAuthModal } = useAuthStore();
  const {
    formData, updateFormData
  } = useFlightSearchStore();
  const {
    FlightClass,
    DepartureDate,
    ReturnDate,
    numberOfAdults,
    DestinationLocationCode,
    OriginLocationCode,
    numberOfInfants,
    numberOfChildren,
    tripType,
    multiCity
  } = formData
  const [payload, setPayload] = useState<FlightSearchStore>(formData);

  const numberOfPassengers = useMemo(() => {
    return numberOfAdults + (numberOfChildren || 0) + (numberOfInfants || 0);
  }, [numberOfAdults, numberOfChildren, numberOfInfants]);

  const allAirports = [...airports]
  const isRoundTrip = tripType === 'round_trip';
  const isMultiCity = tripType === 'multi_city' && multiCity?.length > 0;
  
  const departure = isMultiCity ? multiCity[0].DepartureDate : DepartureDate;
  const arrival = isMultiCity ? multiCity[multiCity.length - 1].DepartureDate : ReturnDate;
  const originCode = isMultiCity ? multiCity[0].OriginLocationCode : OriginLocationCode;
  const destinationCode = isMultiCity ? multiCity[multiCity.length - 1].DestinationLocationCode : DestinationLocationCode;
  const departureInput = (payload?.DepartureDate as any)?.DepartureDate ?? payload?.DepartureDate;
  const hasReturnDate =
    Boolean((departureInput as any)?.to && typeof (departureInput as any).to !== "function") ||
    Boolean((departureInput as any)?._i?.to);
  const tripTypeFromDate = hasReturnDate ? 'round_trip' : 'one_way';

  const handleSubmit = (cities) => {
    const payloadData = cities ? { ...payload, multiCity: generateMultiCityFlightRoutes(cities), isDomestic: false } : { ...payload, tripType: tripTypeFromDate };
    refetchSearch(payloadData);
    updateFormData(payloadData);
    onModifyChange(false);
  }

  const handleChange = (object) => {
    setPayload({ ...payload, ...object });
  }

  return (
    <Container ref={modalContainerRef}>
      <div className="container">

        <Wrapper>
          <SearchContainer>
            <SearchWrapper onClick={() => {
              onModifyChange(true);
            }}>
              <SearchItemWrapper>
                <StyledParagraph style={{ fontWeight: 600 }}>
                  {tripType === 'one_way' ? 'One -way' : tripType === 'round_trip' ? 'Round-trip' : 'Multi-city'}
                </StyledParagraph>
              </SearchItemWrapper>

              <SearchItemWrapper>
                <StyledParagraph style={{ fontWeight: 600 }}>
                  {getAirportStateName(allAirports, originCode)}
                </StyledParagraph>
                <Divider />
                <StyledParagraph style={{ fontWeight: 600 }}>
                  {getAirportStateName(allAirports, destinationCode)}
                </StyledParagraph>
              </SearchItemWrapper>

              <SearchItemWrapper>
                <StyledParagraph style={{ fontWeight: 600 }}>
                  {isRoundTrip || isMultiCity
                    ? `${moment(departure).format("ddd, DD MMM")} - ${isMultiCity
                      ? moment(arrival).format("ddd, DD MMM")
                      : formatReturnDisplayDate(departure)
                    }`
  : formatDisplayDate(departure)}
                </StyledParagraph>

                <Divider />

                <StyledParagraph style={{ fontWeight: 600 }}>
                  Travellers: {numberOfPassengers}
                </StyledParagraph>

                <StyledParagraph style={{ fontWeight: 600 }}>
                  {FlightClass}
                </StyledParagraph>
              </SearchItemWrapper>

              <SearchItemWrapper isModifyBtn>
                <SearchIcon width={14} height={14} />
                <StyledParagraph style={{ color: PRIMARY }}  >
                  Modify search
                </StyledParagraph>
              </SearchItemWrapper>
            </SearchWrapper>
          </SearchContainer>
        </Wrapper>
      </div>

      <Modal
        open={modify}
        footer={null}
        onCancel={() => onModifyChange(false)}
        width={980}
        bodyStyle={{
          height: "auto"
        }}
        getContainer={modalContainerRef.current as HTMLElement}
        className="search-form"
      >
        <FlightSearchDesktop onSubmit={handleSubmit} onChange={handleChange} payload={payload} onModifyChange={onModifyChange} />
      </Modal>
    </Container>
  );
}

FlightDesktopHeader.defaultProps = {
  name: undefined,
  navigateHandler: undefined,
};

export default FlightDesktopHeader;
